import { useEffect, useState } from 'react'
import { loadBonus, isoWeek } from '../lib/day'
import { getResult } from '../lib/storage'

/** The ⚡ weekly-bonus entry card. `hideIfPlayed` keeps the results screen tight. */
export function BonusCard({ hideIfPlayed }: { hideIfPlayed?: boolean }) {
  const [state, setState] = useState<'loading' | 'none' | 'play' | 'played'>('loading')
  const week = isoWeek()
  useEffect(() => {
    if (getResult(`${week}-bonus`)) { setState('played'); return }
    loadBonus(week).then((b) => setState(b ? 'play' : 'none'))
  }, [week])
  if (state === 'loading' || state === 'none') return null
  if (state === 'played' && hideIfPlayed) return null
  const r = getResult(`${week}-bonus`)
  return (
    <a className="card upsell bonus-card" href="#/bonus">
      <span>⚡</span>
      {state === 'played'
        ? <span><b>Weekly bonus played</b> — {r!.score.toLocaleString('en-US')}/5,000 · new one Monday</span>
        : <span><b>Weekly bonus waiting</b> — 5 wild questions · ⏱ 30s each</span>}
      <span>→</span>
    </a>
  )
}
